
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.04 4.841a.574.574 0 01-.4.159h-.282a.59.59 0 01-.4-.159L.111 1.128a.351.351 0 010-.512L.644.104a.378.378 0 01.525 0l3.329 3.214L7.829.106a.386.386 0 01.533 0l.525.512a.351.351 0 010 .512z","fill":"#8c8c8c"}})])
          )
        }
      }
    